import { createContext, FC, useContext, useEffect, useReducer } from 'react';
import { AzureAuthentificator, WindowsAuthentificator } from '.';
import { Role } from '../../enums';
import { actions, IAuthConfig, IAuthContext } from './authModels';
import { authInitialState, authReducer } from './authReducer';

const AuthenticationContext = createContext<IAuthContext>({} as IAuthContext);

let authType: string | null = null;

export let getToken: () => Promise<string>;

export const getAuthType = () => {
    return authType;
};

const setAuthType = (value: string) => {
    authType = value;
};

const AuthenticationContextProvider: FC = (props) => {
    const [{ isAuthenticated, roles, username, assembly, authType }, dispatch] = useReducer(authReducer, authInitialState);

    useEffect(() => {
        getAuthenticationSettings();
    }, []);

    const saveRoles = (roles: string[], username: string) => {
        dispatch(
            actions.initAzureSettings({
                roles: roles,
                username: username
            })
        );
    };

    const getAuthenticationSettings = async () => {
        const response: IAuthConfig = await (await fetch('/api/config/auth-settings')).json();

        setAuthType(response.type);

        dispatch(actions.init({ authType: response.type, assembly: response.assembly }));
    };

    const hasAccess = (..._roles: Role[]): boolean => {
        return isAuthenticated && roles && roles.some((e) => _roles.includes(e as Role));
    };

    if (!authType) {
        return null;
    }

    return (
        <AuthenticationContext.Provider
            value={{
                username: username,
                assembly: assembly,
                authType: authType,
                isAuthenticated: isAuthenticated,
                hasRole: roles?.length > 0,
                hasAccess
            }}
        >
            {authType === 'Azure' ? <AzureAuthentificator saveRoles={saveRoles} /> : <WindowsAuthentificator saveRoles={saveRoles} />}
            {roles?.length > 0 && isAuthenticated && props.children}
        </AuthenticationContext.Provider>
    );
};

const useAuthentication = () => useContext(AuthenticationContext);

export { AuthenticationContextProvider, useAuthentication, AuthenticationContext };
